import config from 'react-global-configuration';

export const LANGUAGE_SET = 'LANGUAGE_SET';
export function setLanguage(language) {
  return {
    type: LANGUAGE_SET,
    language,
  };
}

export const ROOT_CLASSES_ADD = 'ROOT_CLASSES_ADD';
export function addRootClasses(classes) {
  return {
    type: ROOT_CLASSES_ADD,
    classes,
  };
}

export const ROOT_CLASSES_REMOVE = 'ROOT_CLASSES_REMOVE';
export function removeRootClasses(classes) {
  return {
    type: ROOT_CLASSES_REMOVE,
    classes,
  };
}

export const ENABLE_MAINTENANCE_MODE = 'ENABLE_MAINTENANCE_MODE';
export function enableMaintenanceMode() {
  return {
    type: ENABLE_MAINTENANCE_MODE,
  };
}

export const DISABLE_MAINTENANCE_MODE = 'DISABLE_MAINTENANCE_MODE';
export function disableMaintenanceMode() {
  return {
    type: DISABLE_MAINTENANCE_MODE,
  };
}

export const SET_CHECKBOX = 'SET_CHECKBOX';
export function setCheckbox(id, checked) {
  return {
    type: SET_CHECKBOX,
    id,
    checked,
  };
}

export const SHOW_APP_SWITCHER = 'SHOW_APP_SWITCHER';
export function showNativeAppSelector() {
  return {
    type: SHOW_APP_SWITCHER,
  };
}

export const OPEN_PUSH_NOTIFICATION_SETTINGS = 'OPEN_PUSH_NOTIFICATION_SETTINGS';
export function openPushNotificationSettings() {
  return {
    type: OPEN_PUSH_NOTIFICATION_SETTINGS,
  };
}

export const REQUEST_REACT_NATIVE_LOGOUT = 'REQUEST_REACT_NATIVE_LOGOUT';
export function requestReactNativeLogout() {
  return {
    type: REQUEST_REACT_NATIVE_LOGOUT,
  };
}

export const REQUEST_REACT_NATIVE_DELETE_USER = 'REQUEST_REACT_NATIVE_DELETE_USER';
export function requestReactNativeDeleteUser() {
  return {
    type: REQUEST_REACT_NATIVE_DELETE_USER,
  };
}

export const TRACK_EVENT = 'TRACK_EVENT';

export const SHOW_MOBILE_MENU = 'SHOW_MOBILE_MENU';
export function showMobileMenu() {
  return (dispatch) => {
    document.body.classList.add('show-nav');
    dispatch({ type: SHOW_MOBILE_MENU });
  };
}

export const HIDE_MOBILE_MENU = 'HIDE_MOBILE_MENU';
export function hideMobileMenu() {
  return (dispatch) => {
    document.body.classList.remove('show-nav');
    dispatch({ type: HIDE_MOBILE_MENU });
  };
}

export const SET_CURRENT_DOMAIN = 'SET_CURRENT_DOMAIN';
export function setCurrentDomain(domain) {
  return (dispatch) => {
    dispatch({
      type: SET_CURRENT_DOMAIN,
      domain,
    });
  };
}

export const CRISIS_ALERTS_FETCHED = 'CRISIS_ALERTS_FETCHED';
export function fetchCrisisAlerts() {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/api/v1/crisis-alerts`, {
        credentials: 'include',
      }).then((res) => res.json()
        .then((payload) => {
          dispatch({
            type: CRISIS_ALERTS_FETCHED,
            payload,
          });
          resolve(payload);
        }).catch((err) => {
          reject(err);
        }),
      );
    });
  };
}

export const HIDE_CRISIS_ALERT = 'HIDE_CRISIS_ALERT';
export function hideCrisisAlert(nid) {
  return (dispatch) => {
    dispatch({
      type: HIDE_CRISIS_ALERT,
      nid,
    });
  };
}

/**
 * Track an event through redux-beacon
 * @param {*} category a category.
 * @param {*} action an action performed by the user.
 * @param {*} label A label associated to give context to the category.
 * @param {number} value A value ( if applicable. )
 * @returns {Array} action.
 */
export const trackEvent = (category, action, label, value) => {
  return {
    type: TRACK_EVENT,
    category: category,
    action: action,
    label: label,
    value: value,
  };
};

export const COOKIE_CONSENT_GRANTED = 'COOKIE_CONSENT_GRANTED';

/**
 * Tell redux-beacon and GTM to load additional tags after consent.
 * @returns {Array} action.
 */
export const cookieConsentGranted = () => {
  return {
    type: COOKIE_CONSENT_GRANTED,
  };
};

export const TOGGLE_SUPPORT_TOOL = 'TOGGLE_SUPPORT_TOOL';
export const toggleSupportTool = (show) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_SUPPORT_TOOL,
      payload: show,
    });
  };
};
